import { Resource } from './index'

export const resources: Resource = {
  region: 'test',
  values: 'https://search-ext-apigtwy-service.retailgeneral3t.c1.vanguard.com/search/coveo-values',
  autosuggest: 'https://search-ext-apigtwy-service.retailgeneral3t.c1.vanguard.com/search/autosuggest',
  querySuggest: 'https://search-ext-apigtwy-service.retailgeneral3t.c1.vanguard.com/search/coveo-querySuggest',
  coveoAnalytics: 'https://search-ext-apigtwy-service.retailgeneral3t.c1.vanguard.com/search/coveo-analytics',
  profileLink: 'https://search-ext-apigtwy-service.retailgeneral3t.c1.vanguard.com/search/profile-link',
  retailSearchResultsPage: 'https://satinvestor.vanguard.com/search#q=',
  adobeDataLayer: 'https://satpersonal1.vanguard.com/laa-ret-etm-adobe-launch-webapp/static/adobe-data-layer.js',
  adobeStaging: 'https://corp-etm-arl.webt.vanguard.com/personal_investor/379f26abac75/9fc4b472fc7d/launch-7be5aedd8708-staging.min.js',

}

export default resources
